import React, { Component } from "react";


//Import CSS
import "./menu-lateral.css";

class MenuLateral extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_option: 1,
    };
  }
  handleChangeOption(option) {
    if (option !== this.state.selected_option) {
      this.setState({
        selected_option: option,
      });
      if(this.props?.ChangeOption)this.props.ChangeOption(option);

    }
  }
  getOptionsSelected = () =>{
    return this.state.selected_option;
  }
  render() {
    return (
    <div className="MenuLateral_container">
      <div className="MenuLateral_menu-options">
        {this.props.children}
        <div className="MenuLateral_menu-itens">

          {this.props?.menuOptions.map((option) =>  (
            <button key={option.id} className={this.state.selected_option === option.id ? "selected" : ""} onClick={() => this.handleChangeOption(option.id)}>
            {option.label}
          </button>
            
          ))}
          
          
        </div>
        
      </div>
      
      <div className="MenuLateral_selected-page">
         {this.props?.menuOptions.filter(option => option.id === this.state.selected_option).map(option => option.component)}
      </div>
    </div>
    );
  }
}

export default MenuLateral;